import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import classNames from 'classnames';
import css from './styles.module.scss';
import { Button, TextField, Typography, Divider, Box } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import { useForm } from 'react-hook-form';
import { VerticalPopver } from '~/features/dashboard/components/vertical-popover';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import { TextFieldOutlined } from '~/common/text-field-outlined';
import { axiosInstance } from '~/api/config/axios.config';
import { findIndex, filter } from 'lodash';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            width: '100%',
            // maxHeight:'150px',
            // overflowY:'auto'
            // maxWidth: 360,
            // backgroundColor: theme.palette.background.paper,
        },
    })
);

interface noteData_props {
    id: number;
    gDealRef: string;
    notes: string;
    completed: number;
    isDelete: number;
}

// interface note_props {
//     // id : number,
//     gDealRef: string;
//     notes: string;
//     completed: number;
//     isDelete: number;
// }

interface TODODRAWER_props {
    dealId?: string;
    toDoData?: any;
    notesData?: any;
    setNotesData: (data: any) => void;
    setToDosData: (data: any) => void;
}

export const DEAL_TODODRAWER: React.FC<TODODRAWER_props> = ({ dealId, toDoData, notesData, setNotesData, setToDosData }) => {
    const classes = useStyles();
    const [NoteChecked, setNoteChecked] = React.useState([0]);
    const [ToDoChecked, setToDoChecked] = React.useState([0]);
    const [isNewNote, setIsNewNote] = React.useState(false);
    const [isNewToDo, setIsNewToDo] = React.useState(false);
    const [isEditNote, setIsEditNote] = React.useState(false);
    const [isEditTodo, setIsEditTodo] = React.useState(false);
    const [editData, setEditData] = React.useState<any>([]);
    const [filterNotesData, setFilterNotesData] = React.useState<noteData_props[]>([]);
    const [filterToDoData, setFilterToDosData] = React.useState<noteData_props[]>([]);

    const [mainFilter, setMainFilter] = React.useState(0);

    const handleNoteToggle = (value: number) => () => {
        const currentIndex = NoteChecked.indexOf(value);
        const newChecked = [...NoteChecked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setNoteChecked(newChecked);
    };

    const handleToDoToggle = (value: number) => () => {
        const currentIndex = ToDoChecked.indexOf(value);
        const newChecked = [...ToDoChecked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setToDoChecked(newChecked);
    };

    const ColorButton = withStyles(theme => ({
        root: {
            color: theme.palette.getContrastText('#000'),
            backgroundColor: '#6aca9b',
            '&:hover': {
                backgroundColor: '#6aca9b',
            },
            borderRadius: '8px',
            textTransform: 'capitalize',
        },
    }))(Button);
    const openCreateNote = () => {
        setIsNewNote(true);
    };
    const openEditNote = () => {
        setIsEditNote(true);
    };
    const openEditTodo = () => {
        setIsEditTodo(true);
    };
    const openCreateToDo = () => {
        setIsNewToDo(true);
    };

    React.useEffect(() => {
        setFilterNotesData(filter(notesData, ['isDelete', 0]));
        setFilterToDosData(filter(toDoData, ['isDelete', 0]));
    }, [notesData, toDoData]);

    const { handleSubmit, register, getValues, errors } = useForm<noteData_props>();

    const sendToDos = (notes: string, actionFor: string) => {
        let data = {
            gDealRef: dealId,
            notes: notes,
            completed: 0,
            isDelete: 0,
        };
        let link = actionFor === 'note' ? 'dealnotes' : 'dealtodo';

        axiosInstance.post(`catalogue/projectCreator/${link}/save`, data).then(({ data }) => {
            if (actionFor === 'note') {
                setNotesData([...notesData, data]);
                setIsNewNote(!isNewNote);
            } else {
                setToDosData([...toDoData, data]);
                setIsNewToDo(!isNewToDo);
            }
        });
    };

    const updateToDos = (notes: string, id: any, completed: any, actionFor: string) => {
        let data = {
            gDealRef: dealId,
            id: id,
            notes: notes,
            completed: completed,
            isDelete: 0,
        };

        let link = actionFor === 'note' ? 'dealnotes' : 'dealtodo';

        axiosInstance.post(`catalogue/projectCreator/${link}/save`, data).then(({ data }) => {
            if (actionFor === 'note') {
                const updatedData = [...notesData];
                const index = findIndex(updatedData, { id: Number(id) });
                updatedData[index] = data;
                setNotesData(updatedData);
                setIsEditNote(false);
            } else {
                const updatedData = [...toDoData];
                const index = findIndex(updatedData, { id: Number(id) });
                updatedData[index] = data;
                setToDosData(updatedData);
                setIsEditTodo(false);
            }
        });
    };

    const handleChecked = (completed: Boolean, id: number, notes: string, isDelete: number, actionFor: string) => {
        let data = {
            id: String(id),
            gDealRef: dealId,
            notes: notes,
            completed: Number(completed),
            isDelete: isDelete,
        };

        let link = actionFor === 'note' ? 'dealnotes' : 'dealtodo';

        axiosInstance.post(`catalogue/projectCreator/${link}/save`, data).then(({ data }) => {
            if (actionFor === 'note') {
                const updatedData = [...notesData];
                const index = findIndex(updatedData, { id: Number(id) });
                updatedData[index] = data;
                setNotesData(updatedData);
                setIsEditNote(false);
            } else {
                const updatedData = [...toDoData];
                const index = findIndex(updatedData, { id: Number(id) });
                updatedData[index] = data;
                setToDosData(updatedData);
                setIsEditTodo(false);
            }
        });
    };

    const handleDelete = (completed: number, id: number, notes: string, isDelete: number, actionFor: string) => {
        let data = {
            id: String(id),
            gDealRef: dealId,
            notes: notes,
            completed: Number(completed),
            isDelete: 1,
        };

        let link = actionFor === 'note' ? 'dealnotes' : 'dealtodo';

        axiosInstance.post(`catalogue/projectCreator/${link}/save`, data).then(({ data }) => {
            if (actionFor === 'note') {
                const updatedData = [...notesData];
                const index = findIndex(updatedData, { id: Number(id) });
                updatedData[index] = data;
                setNotesData(filter(updatedData, ['isDelete', 0]));
                setIsEditNote(false);
            } else {
                const updatedData = [...toDoData];
                const index = findIndex(updatedData, { id: Number(id) });
                updatedData[index] = data;
                setToDosData(filter(updatedData, ['isDelete', 0]));
                setIsEditTodo(false);
            }
        });
    };

    const handleEdit = (completed: number, id: number, notes: string, isDelete: number, actionFor: string) => {
        let data = {
            id: String(id),
            gDealRef: dealId,
            notes: notes,
            completed: Number(completed),
            isDelete: 0,
        };

        if (data) {
            setEditData(data);
        }
        if (actionFor === 'note') {
            openEditNote();
        } else {
            openEditTodo();
        }
    };

    return (
        <>
            <div style={{ padding: '1rem', width: '50vw' }} className={css.tododealDrawer}>
                <Box display="flex" justifyContent="center">
                    <ToggleButtonGroup
                        value={mainFilter}
                        exclusive
                        onChange={(omit, value) => setMainFilter(value)}
                        aria-label="toggle data view"
                        className={css.toggleButtonGroup}
                    >
                        <ToggleButton value={0} aria-label="My Action Points">
                            My Action Points
                        </ToggleButton>
                        <ToggleButton value={1} aria-label="My Notes">
                            My Notes
                        </ToggleButton>
                    </ToggleButtonGroup>
                </Box>
                {mainFilter === 0 && !isEditNote && !isEditTodo && (
                    <div className={css.module} style={{ padding: '1rem' }}>
                        {isNewToDo ? (
                            <>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <h1>Create To Do</h1>
                                    <div>
                                        <ColorButton variant="contained" color="primary" onClick={() => setIsNewToDo(!isNewToDo)} style={{borderRadius: '8px'}}>
                                            Close
                                        </ColorButton>
                                    </div>
                                </div>
                                <form onSubmit={handleSubmit(() => {})}>
                                    <TextField type="number" name={'completed'} inputRef={register({ required: true })} hidden value={0} defaultValue={0} />
                                    <TextField
                                        type="number"
                                        name={'gDealRef'}
                                        hidden
                                        inputRef={register({ required: true })}
                                        value={`${dealId}`}
                                        defaultValue={`${dealId}`}
                                    />
                                    <TextFieldOutlined
                                        fullWidth
                                        inputRef={register({ required: 'Note is required' })}
                                        name="notes"
                                        variant="filled"
                                        // placeholder={'Type your here.'}
                                        multiline
                                        label={'Todo'}
                                        error={!!errors?.notes}
                                        helperText={errors?.notes?.message}
                                    />
                                    <div style={{ display: 'flex', marginTop: '2rem' }}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            type="submit"
                                            onClick={() => {
                                                sendToDos(getValues('notes'), 'todo');
                                            }}
                                            disableElevation
                                            style={{borderRadius: '8px'}}
                                        >
                                            Save
                                        </Button>
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            disableElevation
                                            onClick={() => setIsNewToDo(!isNewToDo)}
                                            style={{borderRadius: '8px', marginLeft: '1rem'}}
                                        >
                                            Cancel
                                        </Button>
                                    </div>
                                </form>
                            </>
                        ) : (
                            <>
                                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                    <div>
                                        <ColorButton className={css.actionpointbtn} variant="contained" color="primary" onClick={() => openCreateToDo()} style={{borderRadius: '8px'}}>
                                            Add Action Point
                                        </ColorButton>
                                    </div>
                                </div>
                                {filterToDoData.filter(a => a.completed === 0).length > 0 ? <Typography variant="h6">Incompleted</Typography> : <></>}
                                <List className={classNames(classes.root)}>
                                    {filterToDoData
                                        .filter(a => a.completed === 0)
                                        .map(note => {
                                            const labelId = `checkbox-list-label-${note.id}`;

                                            return (
                                                <ListItem
                                                    key={note.id}
                                                    role={undefined}
                                                    dense
                                                    button
                                                    className={css.listRow}
                                                    onClick={handleToDoToggle(note.id)}
                                                    style={{ padding: '0', wordBreak: 'break-word' }}
                                                >
                                                    <ListItemIcon>
                                                        <Checkbox
                                                            edge="start"
                                                            checked={Boolean(note.completed)}
                                                            tabIndex={-1}
                                                            disableRipple
                                                            onChange={() => handleChecked(!Boolean(note.completed), note.id, note.notes, note.isDelete, 'todo')}
                                                            inputProps={{ 'aria-labelledby': labelId }}
                                                        />
                                                    </ListItemIcon>
                                                    <ListItemText id={labelId} primary={`${note.notes}`} />
                                                    <ListItemIcon style={{ flexDirection: 'row-reverse' }}>
                                                        <VerticalPopver
                                                            childClassName={css.deleteIcon}
                                                            actionsList={`edit,delete`}
                                                            onClickDelete={() => handleDelete(note.completed, note.id, note.notes, note.isDelete, 'action')}
                                                            onClickEdit={() => handleEdit(note.completed, note.id, note.notes, note.isDelete, 'action')}
                                                        />
                                                    </ListItemIcon>
                                                    {/* <ListItemSecondaryAction>
                                    <IconButton edge="end" aria-label="comments">
                                        <CommentIcon />
                                    </IconButton>
                                </ListItemSecondaryAction> */}
                                                </ListItem>
                                            );
                                        })}
                                </List>

                                {filterToDoData.filter(a => a.completed === 1).length > 0 && (
                                    <>
                                        <Divider />

                                        <Accordion className={css.customaccordian}>
                                            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                                                <Typography>Completed</Typography>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <List className={classNames(classes.root)} style={{ marginTop: '15px' }}>
                                                    {filterToDoData
                                                        .filter(a => a.completed === 1)
                                                        .map(note => {
                                                            const labelId = `checkbox-list-label-${note.id}`;

                                                            return (
                                                                <ListItem
                                                                    key={note.id}
                                                                    className={css.listRow}
                                                                    role={undefined}
                                                                    dense
                                                                    button
                                                                    onClick={handleToDoToggle(note.id)}
                                                                    style={{ padding: '0', wordBreak: 'break-word' }}
                                                                >
                                                                    <ListItemIcon>
                                                                        <Checkbox
                                                                            edge="start"
                                                                            checked={Boolean(note.completed)}
                                                                            tabIndex={-1}
                                                                            disableRipple
                                                                            onChange={() =>
                                                                                handleChecked(
                                                                                    !Boolean(note.completed),
                                                                                    note.id,
                                                                                    note.notes,
                                                                                    note.isDelete,
                                                                                    'todo'
                                                                                )
                                                                            }
                                                                            inputProps={{ 'aria-labelledby': labelId }}
                                                                        />
                                                                    </ListItemIcon>
                                                                    <ListItemText id={labelId} primary={`${note.notes}`} />
                                                                    <ListItemIcon style={{ flexDirection: 'row-reverse' }}>
                                                                        <VerticalPopver
                                                                            childClassName={css.deleteIcon}
                                                                            actionsList={`delete`}
                                                                            onClickDelete={() =>
                                                                                handleDelete(note.completed, note.id, note.notes, note.isDelete, 'todo')
                                                                            }
                                                                        />
                                                                    </ListItemIcon>
                                                                    {/* <ListItemSecondaryAction>
                                    <IconButton edge="end" aria-label="comments">
                                        <CommentIcon />
                                    </IconButton>
                                </ListItemSecondaryAction> */}
                                                                </ListItem>
                                                            );
                                                        })}
                                                </List>
                                            </AccordionDetails>
                                        </Accordion>
                                    </>
                                )}
                            </>
                        )}
                    </div>
                )}
                {/* ///------------------------------------------------------------------------------------------------------------
--------------------------------------------------------------------------------------------------------------------
--------------------------------------------------------------------------------------------------------------------- */}
                {mainFilter === 1 && !isEditNote && !isEditTodo && (
                    <div className={css.module} style={{ padding: '1rem' }}>
                        {isNewNote ? (
                            <>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <h1>Create Note</h1>
                                    <div>
                                        <ColorButton variant="contained" color="primary" onClick={() => setIsNewNote(!isNewNote)} style={{borderRadius: '8px'}}>
                                            Close
                                        </ColorButton>
                                    </div>
                                </div>
                                <form onSubmit={handleSubmit(() => {})}>
                                    <TextField type="number" name={'completed'} inputRef={register({ required: true })} hidden value={0} defaultValue={0} />
                                    <TextField
                                        type="number"
                                        name={'gDealRef'}
                                        hidden
                                        inputRef={register({ required: true })}
                                        value={`${dealId}`}
                                        defaultValue={`${dealId}`}
                                    />
                                    <TextFieldOutlined
                                        fullWidth
                                        inputRef={register({ required: 'Note is required' })}
                                        name="notes"
                                        variant="filled"
                                        multiline
                                        // placeholder={'Type your note here.'}
                                        label={'Note'}
                                        error={!!errors?.notes}
                                        helperText={errors?.notes?.message}
                                    />
                                    <div style={{ display: 'flex', marginTop: '2rem' }}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            type="submit"
                                            onClick={() => {
                                                sendToDos(getValues('notes'), 'note');
                                            }}
                                            disableElevation
                                            style={{borderRadius: '8px'}}
                                        >
                                            Save
                                        </Button>
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            disableElevation
                                            onClick={() => setIsNewNote(!isNewNote)}
                                            style={{borderRadius: '8px', marginLeft: '1rem'}}
                                        >
                                            Cancel
                                        </Button>
                                    </div>
                                </form>
                            </>
                        ) : (
                            <>
                                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                    <div>
                                        <ColorButton variant="contained" color="primary" onClick={() => openCreateNote()}>
                                            Add My Note
                                        </ColorButton>
                                    </div>
                                </div>

                                <List className={classNames(classes.root)}>
                                    {filterNotesData.map(note => {
                                        const labelId = `checkbox-list-label-${note.id}`;

                                        return (
                                            <ListItem
                                                key={note.id}
                                                role={undefined}
                                                className={css.listRow}
                                                dense
                                                button
                                                onClick={handleNoteToggle(note.id)}
                                                style={{ padding: '0', wordBreak: 'break-word' }}
                                            >
                                                <ListItemText id={labelId} primary={`${note.notes}`} />
                                                <ListItemIcon style={{ flexDirection: 'row-reverse' }}>
                                                    <VerticalPopver
                                                        childClassName={css.deleteIcon}
                                                        actionsList={`edit,delete`}
                                                        onClickDelete={() => handleDelete(note.completed, note.id, note.notes, note.isDelete, 'note')}
                                                        onClickEdit={() => handleEdit(note.completed, note.id, note.notes, note.isDelete, 'note')}
                                                    />
                                                </ListItemIcon>
                                                {/* <ListItemSecondaryAction>
                                    <IconButton edge="end" aria-label="comments">
                                        <CommentIcon />
                                    </IconButton>
                                </ListItemSecondaryAction> */}
                                            </ListItem>
                                        );
                                    })}
                                </List>
                                {/* } */}
                            </>
                        )}
                    </div>
                )}
                {isEditNote && (
                    <>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <h1>Edit Note</h1>
                            <div>
                                <ColorButton variant="contained" color="primary" onClick={() => setIsEditNote(!isEditNote)} style={{borderRadius: '8px'}}>
                                    Close
                                </ColorButton>
                            </div>
                        </div>
                        <form onSubmit={handleSubmit(() => {})}>
                            <TextField
                                type="number"
                                name={'completed'}
                                inputRef={register({ required: true })}
                                hidden
                                // value={editData.completed}
                                defaultValue={editData.completed}
                            />
                            <TextField
                                type="number"
                                name={'gDealRef'}
                                hidden
                                multiline
                                inputRef={register({ required: true })}
                                // value={`${dealId}`}
                                defaultValue={`${dealId}`}
                            />
                            <TextField
                                type="number"
                                name={'gNoteid'}
                                hidden
                                inputRef={register({ required: true })}
                                // value={`${editData.id}`}
                                defaultValue={`${editData.id}`}
                            />
                            <TextFieldOutlined
                                multiline
                                fullWidth
                                inputRef={register({ required: 'Note is required' })}
                                name="notes"
                                variant="filled"
                                // placeholder={'Type your note here.'}
                                label={'Note'}
                                // onChange={(e) => setNewNote(e.target.value)}
                                defaultValue={editData.notes}
                                error={!!errors?.notes}
                                helperText={errors?.notes?.message}
                            />
                            <div style={{ display: 'flex', marginTop: '2rem' }}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    type="submit"
                                    onClick={() => {
                                        updateToDos(getValues('notes'), getValues('gNoteid'), getValues('completed'), 'note');
                                    }}
                                    disableElevation
                                    style={{borderRadius: '8px'}}
                                >
                                    Update
                                </Button>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    disableElevation
                                    onClick={() => setIsEditNote(!isEditNote)}
                                    style={{borderRadius: '8px', marginLeft: '1rem'}}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </form>
                    </>
                )}
                {isEditTodo && (
                    <>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <h1>Edit Todo</h1>
                            <div>
                                <ColorButton variant="contained" color="primary" onClick={() => setIsEditTodo(!isEditTodo)} style={{borderRadius: '8px'}}>
                                    Close
                                </ColorButton>
                            </div>
                        </div>
                        <form onSubmit={handleSubmit(() => {})}>
                            <TextField
                                type="number"
                                name={'completed'}
                                inputRef={register({ required: true })}
                                hidden
                                value={editData.completed}
                                defaultValue={editData.completed}
                            />
                            <TextField
                                type="number"
                                name={'gDealRef'}
                                hidden
                                inputRef={register({ required: true })}
                                value={`${dealId}`}
                                defaultValue={`${dealId}`}
                            />
                            <TextField
                                type="number"
                                name={'gNoteid'}
                                hidden
                                inputRef={register({ required: true })}
                                value={`${editData.id}`}
                                defaultValue={`${editData.id}`}
                            />
                            <TextFieldOutlined
                                fullWidth
                                inputRef={register({ required: 'Note is required' })}
                                name="notes"
                                multiline
                                variant="filled"
                                placeholder={'Type your note here.'}
                                label={'Note'}
                                // onChange={(e) => setNewNote(e.target.value)}
                                defaultValue={editData.notes}
                                error={!!errors?.notes}
                                helperText={errors?.notes?.message}
                            />
                            <div style={{ display: 'flex', marginTop: '2rem' }}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    type="submit"
                                    onClick={() => {
                                        updateToDos(getValues('notes'), getValues('gNoteid'), getValues('completed'), 'action');
                                    }}
                                    disableElevation
                                    style={{borderRadius: '8px'}}
                                >
                                    Update
                                </Button>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    disableElevation
                                    onClick={() => setIsEditTodo(!isEditTodo)}
                                    style={{borderRadius: '8px', marginLeft: '1rem'}}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </form>
                    </>
                )}
            </div>
        </>
    );
};
